import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Logo from "./header-bottom/logo/Logo";
import NavMenu from "./header-bottom/navigation/NavMenu";
import IconGroup from "./IconGroup";
import MobileMenu from "./header-bottom/MobileMenu";
import HeaderTop from "./header-top/HeaderTop";
import HomePageActions from "../../redux/actions/home-page.actions";
import { useDispatch, useSelector } from "react-redux";
import CartActions from "../../redux/actions/cart.actions";
import currencyActions from "../../redux/actions/currency.actions";
import utilActions from "../../redux/actions/util.actions";
import CustomerActions from "../../redux/actions/customer.actions";
import store from 'store'
import cartSelector from "../../redux/selectors/cart.selector";
import CouponHeader from "./CouponHeader";
import { useHistory } from "react-router";

const MainHeader = ({
  layout,
  top,
  borderStyle,
  headerPaddingClass,
  headerPositionClass,
  headerBgClass
}) => {
  const [scroll, setScroll] = useState(0);
  const [headerTop, setHeaderTop] = useState(0);
  const dispatch = useDispatch();
  const history = useHistory();
  const { pathname } = history.location;
  const couponList = useSelector(cartSelector.couponList)
  
  useEffect(() => {
    dispatch(HomePageActions.getCategoriesAction());
    dispatch(CartActions.updateCartFromCacheAction())
    dispatch(CartActions.updateWishListFromCacheAction())
    dispatch(CartActions.updateCompareListFromCacheAction())
    dispatch(currencyActions.getCurrencyAction())
    dispatch(utilActions.getSettingsAction())

    const token = store.get('npipl_token_hash')
    if (token) {
      dispatch(CustomerActions.refreshCustomerAction(token))
    } else {
      if (pathname.includes('myAccount')) {
         history.push("/");
      }
    }
  }, []);

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "npipl_token_hash") {
        if (pathname.includes('myAccount') && !e.newValue) {
          history.push("/");
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
}, []);

  useEffect(() => {
    const header = document.querySelector(".sticky-bar");
    setHeaderTop(header.offsetTop);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  return (
    <header
      className={`header-area clearfix ${headerBgClass ? headerBgClass : ""} ${
        headerPositionClass ? headerPositionClass : ""
      }`}
    >
      {
        couponList?.length > 0 &&
        <CouponHeader couponList={couponList} />
      }
      
      <div
        className={`${headerPaddingClass ? headerPaddingClass : ""} ${
          top === "visible" ? "d-lg-block" : "d-none"
        } header-top-area ${
          borderStyle === "fluid-border" ? "border-none" : ""
        }`}
      >
        <div className={layout === "container-fluid" ? layout : "container"}>
          {/* header top */}
          <HeaderTop borderStyle={borderStyle} />
        </div>
      </div>

      <div
        className={` ${
          headerPaddingClass ? headerPaddingClass : ""
        } sticky-bar header-res-padding clearfix ${
          scroll > headerTop ? "stick" : ""
        }`}
      >
        <div className={layout === "container-fluid" ? layout : "container"}>
          <div className="row">
            <div className="col-xl-2 col-lg-2 col-md-6 col-xs-6 col-6">
              {/* header logo */}
              <Logo imageUrl="/assets/images/narayana-logo.jpg" logoClass="logo-container" />
            </div>
            <div className="col-xl-8 col-lg-8 d-none d-lg-block header-block">
              {/* Nav menu */}
              <NavMenu />
            </div>
            <div className="col-xl-2 col-lg-2 col-md-6 col-xs-6 col-6">
              {/* Icon group */}
              <IconGroup />
            </div>
          </div>
        </div>
        {/* mobile menu */}
        <MobileMenu />
      </div>
    </header>
  );
};

MainHeader.propTypes = {
  borderStyle: PropTypes.string,
  headerPaddingClass: PropTypes.string,
  headerPositionClass: PropTypes.string,
  layout: PropTypes.string,
  top: PropTypes.string
};

export default MainHeader;
